import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork";
import { OrderInstlalmentsReportByVpList } from "../../common/types/OrderInstlalmentsReportByVpList";
import { FetchResultType } from "../fetchTypes";

export const getOrderInstallmentsReportByVp = createAsyncThunk(
    "/OrderInstallmentsReport/get-daily-report-per-vp",
    async (parameters: any, { rejectWithValue }) => {
        try {
            const method = "/OrderInstallmentsReport/get-daily-report-per-vp";

            const { data, errorMessage, isSuccess } = await commonNetwork.get(method, parameters);

            if (isSuccess) {
                return data;
            } else {
                return rejectWithValue(errorMessage);
            }
        }
        catch (error: any) {
            return rejectWithValue(error.data.message);
        }
    }
);

export interface orderInstallmentsReportByVpStateType extends FetchResultType {
    orderInstallmentsReport: OrderInstlalmentsReportByVpList[]
}

export const orderInstallmentsReportPerVpSlice = createSlice({
    name: "orderInstallmentsReportPerVp",
    initialState: {
        orderInstallmentsReport: [],
        isfirmAvailable: true,
        isFetching: false,
        isSuccess: false,
        isError: false,
        errorMessage: "",
        isFetchComplete: false
    },
    reducers: {
        clearState: (state) => {
            state.orderInstallmentsReport = [];
            state.isFetching = false;
            state.isSuccess = false;
            state.isError = false;
            state.isFetchComplete = false;
            return state;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getOrderInstallmentsReportByVp.fulfilled, (state, { payload }) => {
            state.orderInstallmentsReport = payload;
            state.isFetching = false;
            state.isSuccess = true;
            state.isError = false;
            state.isFetchComplete = true;
            return state;
        });
        builder.addCase(getOrderInstallmentsReportByVp.rejected, (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            state.errorMessage = payload as string;
            state.isFetchComplete = true;
            return state;
        });
        builder.addCase(getOrderInstallmentsReportByVp.pending, (state) => {
            state.isFetching = true;
            return state;
        });
    }
}); 

export const { clearState } = orderInstallmentsReportPerVpSlice.actions;
export const orderInstallmentsReportSelector = (state: any) => state.getOrderInstallmentsReportByVp;
export const orderInstallmentsReportPerVpReducer = orderInstallmentsReportPerVpSlice.reducer;